import { plans as DefaultPlans, hardware, orgs } from '@/data/index'

const flags = WR_CHECKOUT_GLOBALS?.flags || {
    freeGiftAvailable: false,
    shortBatAvailable: true,
}

// swap out free short_bat for bat_attachment if short_bat is not available
export const plans = flags.shortBatAvailable
    ? DefaultPlans
    : DefaultPlans.map((plan) => {
        const free_hardware_categories = plan.free_hardware_categories || []
        if (free_hardware_categories.includes('short_bat')) {
            free_hardware_categories.splice(free_hardware_categories.indexOf('short_bat'), 1)
            if (!free_hardware_categories.includes('bat_attachment')) {
                free_hardware_categories.push('bat_attachment')
            }
        }
        return {
            ...plan,
            free_hardware_categories,
        }
    })

export const planHardwareOptions = (plan: StripePlan, bundle?: boolean) => {
    const free_hardware_categories = plan.free_hardware_categories || []
    return hardware.filter((item: Hardware) => {
        if (!bundle && item.bundle_only) return false
        if (item.category === 'short_bat' && !flags.shortBatAvailable) return false
        return free_hardware_categories.includes(item.category) ? item.price === 0 : item.price > 0
    })
}

export const getPlan = (planGroupKey: string, billing_interval: IntervalOption = 'monthly') => {
    const stripePlanOptions: StripePlan[] = plans
        .filter((plan) => plan.group_key === planGroupKey && !plan.is_archived)
        .map((plan) => {
            const hardware_options = planHardwareOptions(plan)
            return {
                ...plan,
                hardware_options,
            }
        })

    const selectedPlan: StripePlan | undefined = stripePlanOptions.find((plan) => plan.billing_interval === billing_interval)
    const selectedStripePlanId = selectedPlan?.stripe_price_id
    return {
        stripePlanOptions,
        selectedPlan,
        selectedStripePlanId,
    }
}
interface GroupKeyedPlan {
    monthly: StripePlan;
    yearly: StripePlan;
}

export const plansByGroupKey = (stripePlans: StripePlan[]): Record<string, GroupKeyedPlan> => {
    return [...new Set(stripePlans.map((plan) => plan.group_key))].reduce((previous, groupKey) => {
        return {
            ...previous,
            [groupKey]: {
                monthly: getPlan(groupKey, 'monthly').selectedPlan,
                yearly: getPlan(groupKey, 'yearly').selectedPlan,
            },
        }
    }, {})
}

export const getPlanByStripePriceId = (stripePriceId: string): StripePlan | undefined => {
    return plans.find((plan) => plan.stripe_price_id === stripePriceId)
}

